/**
 * Owner 2026-10-27 12:26 („musisz mi powiedzieć, do kogo wysyłasz”): every dialog that sends something to people says
 * to whom before „Wyślij” — „Wyślę do: Jan Kowalski, Ola Nowak”. Rule 7a: when a name is hidden from the role, only how
 * many — „Wyślę do 3 osób”.
 */
export function recipientsText(list: ReadonlyArray<{ name?: string | undefined }>): string {
  if (list.length === 0) return 'Nie ma do kogo wysłać';
  if (list.every((p) => p.name)) return `Wyślę do: ${list.map((p) => p.name).join(', ')}`;
  return `Wyślę do ${countText(list.length, 'genitive')}`;
}

/** „1 osoba”, „2 osoby”, „5 osób”; genitive („do …”): „1 osoby”, „2 osób”. */
export function countText(n: number, form: 'nominative' | 'genitive' = 'nominative'): string {
  if (n === 1) return form === 'genitive' ? '1 osoby' : '1 osoba';
  const ones = n % 10;
  const tens = n % 100;
  return `${n} ${form === 'nominative' && ones >= 2 && ones <= 4 && (tens < 12 || tens > 14) ? 'osoby' : 'osób'}`;
}
